import { render, staticRenderFns } from "./systemPlatform.vue?vue&type=template&id=1f11d8a7&scoped=true"
import script from "./systemPlatform.vue?vue&type=script&lang=js"
export * from "./systemPlatform.vue?vue&type=script&lang=js"
import style0 from "./systemPlatform.vue?vue&type=style&index=0&id=1f11d8a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f11d8a7",
  null
  
)

export default component.exports